import AboutAirline from './AboutAirline';

export default AboutAirline;
